let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("e8MPB")).then(() => parcelRequire('dLctv'));